import { Popover } from 'antd';
import { messageMenu } from '@/configs/router/menu';
import { useChatContext } from '@/contexts/chat/context';
import { useSessionContext } from '@/contexts/session/context';
import styles from './index.module.scss';
import TypeIcon from './images/type.svg?react';

const MessageHeader = () => {
  const {
    session: { user },
  } = useSessionContext();
  const { singleEncryption, groupEncryption } = useChatContext();

  const hasSingleAndGroupKey = useMemo(
    () => singleEncryption.hasSingleKey && groupEncryption.hasGroupKey,
    [groupEncryption.hasGroupKey, singleEncryption.hasSingleKey]
  );

  const handleRetryUploadKey = useCallback(() => {
    if (user?.userId) {
      singleEncryption.checkAndSetKeyPackage(user?.userId);
      groupEncryption.checkAndSetKeyPackage(user?.userId);
    }
  }, [groupEncryption, singleEncryption, user?.userId]);

  return (
    <div className={styles.messageHeader}>
      {!hasSingleAndGroupKey && (
        <div className={styles.networkError}>
          Network error(10), <span onClick={handleRetryUploadKey}>Please retry</span>
        </div>
      )}

      <div className={styles.messageNav}>
        <div className={styles.test}>
          <Popover
            rootClassName={styles.msgTypePopoverWrapper}
            placement="bottomLeft"
            arrow={false}
            content={
              <div className={styles.popoverContent}>
                {messageMenu.map((item) => {
                  return (
                    <Link
                      className={styles.msgNavItem}
                      key={item.key}
                      to={item.key as string}
                    >
                      <div>{item.icon}</div>
                      <div>{item.label}</div>
                    </Link>
                  );
                })}
              </div>
            }
          >
            <div className={styles.msgTypeIcon}>
              <TypeIcon />
            </div>
          </Popover>
        </div>
        <div>Messages</div>
      </div>
    </div>
  );
};
export default MessageHeader;
